module.exports = __webpack_public_path__ + "static/media/reading-girl.09273239.png";